import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useController } from 'react-hook-form'

const InputField = ({
  errorProps = {},
  inputProps = {},
  labelProps = {},
  name,
}) => {
  const id = `id-${name}`
  const { label, required } = labelProps
  const { message, ignoreError } = errorProps
  const placeholder = inputProps.placeholder || 'enter value'

  const { field, fieldState: { error } } = useController({ name })
  const errorId = `${id}-error`
  const showError = !ignoreError && error && message

  return (
    <>
      <label htmlFor={id}>
        {label && <span className={clsx({ required })}>{label}</span>}
      </label>
      <input
        id={id}
        placeholder={placeholder}
        aria-invalid={!ignoreError && error ? true : undefined}
        aria-describedby={showError ? errorId : undefined}
        {...field}
        {...inputProps}
      />
      {showError && <span id={errorId} className="form-error-msg" role="alert">{message}</span>}
    </>
  )
}

InputField.propTypes = {
  inputProps: PropTypes.shape({
    placeholder: PropTypes.string,
  }),
  errorProps: PropTypes.shape({
    message: PropTypes.string,
    ignoreError: PropTypes.bool,
  }),
  labelProps: PropTypes.shape({
    label: PropTypes.string,
    required: PropTypes.bool,
  }),
  name: PropTypes.string.isRequired,
}

export default InputField
